module.exports = __webpack_public_path__ + "static/AddNewVerify-ba48f464b7abfaeb01fd726f8e6a6f03.png";